import useSWR from 'swr';
import { fetcher } from '../base';

export const checkoutItemsEndpoint = '/checkout/items';

export function useCheckoutItems() {
  return useSWR(checkoutItemsEndpoint, fetcher);
}
